import { render, staticRenderFns } from "./AddMedicalFileDialog.vue?vue&type=template&id=1f2478d0"
import script from "./AddMedicalFileDialog.vue?vue&type=script&lang=js"
export * from "./AddMedicalFileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports